module.exports = __webpack_public_path__ + "img/BACK_ARROW_GREEN.ea11ac7d.svg";